import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { SearchQuestionnaireBottomPanel } from './SearchQuestionnaireBottomPanel.component'

const withUnmountHoc = withUnmountTransition(SearchQuestionnaireBottomPanel)
export { withUnmountHoc as SearchQuestionnaireBottomPanel }
